import { UUID } from '@hfc/common/src/types/UUID';
import { APPLICATION_TYPES } from '@hfc/common/src/types/ApplicationTypes';
import { EnrollmentRepository } from '@/application/shared/domain/EnrollmentRepository';
import { UseCase } from '@/shared/application/UseCase';
import { SfApiResponse } from '@hfc/ui-core';
import { ChallengeQuestionSettings, ChallengeType } from '@/application/shared/domain/ChallengeQuestionSettings';
import { OtpChannelType } from '@/shared/domain/OtpChannelType';

export class SendSelectedChannelUseCase implements UseCase<[APPLICATION_TYPES, ChallengeType, UUID, OtpChannelType], SfApiResponse<ChallengeQuestionSettings>> {

  private repository: EnrollmentRepository;

  public constructor (repository: EnrollmentRepository) {
    this.repository = repository;
  }

  public async run (input: [APPLICATION_TYPES, ChallengeType, UUID, OtpChannelType]): Promise<SfApiResponse<ChallengeQuestionSettings>> {
    const [type, challengeType, uuid, channel] = input;

    return await this.repository.sendSelectedChannel(type, challengeType, uuid, channel);
  }

}
